import { render, staticRenderFns } from "./RatificacionesDigital.vue?vue&type=template&id=8801586a&scoped=true"
import script from "./RatificacionesDigital.vue?vue&type=script&lang=js"
export * from "./RatificacionesDigital.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8801586a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8801586a')) {
      api.createRecord('8801586a', component.options)
    } else {
      api.reload('8801586a', component.options)
    }
    module.hot.accept("./RatificacionesDigital.vue?vue&type=template&id=8801586a&scoped=true", function () {
      api.rerender('8801586a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/ratificacionesdigital/RatificacionesDigital.vue"
export default component.exports